exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.card__view-btn span[data-v-07097d9d] {\n  margin-left: 8px;\n}\n", ""]);

